import Vue from 'vue'
import Router from 'vue-router'

const vQuestion = () => import('../components/v-question-page')
const vPayment = () => import('../components/v-payment-page')
const vContact = () => import('../components/v-contact-page')
const vFrequently = () => import('../components/v-frequently-page')
const vRules = () => import('../components/v-rules-page')
const vProgram = () => import('../components/v-program-page')

Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: '/',
            component: vQuestion
        },
        {
            path: '/payment',
            name: 'payment',
            component: vPayment
        },
        {
            path: '/contact',
            name: 'contact',
            component: vContact
        },
        {
            path: '/frequently',
            name: 'frequently',
            component: vFrequently
        },
        {
            path: '/rules',
            name: 'rules',
            component: vRules
        },
        {
            path: '/program',
            name: 'program',
            component: vProgram
        }
    ]
});

export default router;